import {
  createContext,
  useContext,
  useState,
} from "react";

const ReviewModeContext = createContext();

export function ReviewModeProvider({
  children,
}) {
  const [reviewMode, setReviewMode] =
    useState(false);

  return (
    <ReviewModeContext.Provider
      value={{
        reviewMode,
        setReviewMode,
      }}
    >
      {children}
    </ReviewModeContext.Provider>
  );
}

export function useReviewMode() {
  return useContext(ReviewModeContext);
}